import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { serviceWorkerUserIdFactory } from '../service-worker-user-id.factory';
import { DigestService } from './digest.service';

let resultPromise: Promise<string>;

async function getSaltedHashServiceWorkerUserIdPromise(
    clientStartupConfigService: ClientStartupConfigService,
    digestService: DigestService
) {
    // Run the regular ServiceWorkerModule factory for acquiring the Service Worker User Cache ID
    const serviceWorkerCacheId = await serviceWorkerUserIdFactory(clientStartupConfigService)();
    return digestService.saltedHash(serviceWorkerCacheId);
}

export function saltedHashServiceWorkerUserIdFactory(
    clientStartupConfigService: ClientStartupConfigService,
    digestService: DigestService
): () => Promise<string> {
    // Provide a function that will obtain the service worker user ID lazily.
    // This is to ensure that getting the ID doesn't run during app startup
    return () => {
        if (!resultPromise) {
            resultPromise = getSaltedHashServiceWorkerUserIdPromise(clientStartupConfigService, digestService);
        }
        return resultPromise;
    };
}
